import styled from "styled-components";
import Card from "../../components/Card";
import "./articles.css";
import PageHeader from "../../components/PageHeader";
import { Link, useNavigate } from "react-router-dom";
import { Badge, Button, Input, InputNumber, Popconfirm, PopconfirmProps, Segmented, Spin, Table, Tag, Tooltip, Typography, message } from "antd";
import { useContext, useEffect, useState } from "react";
import { CheckCircleOutlined, CloseCircleOutlined, ExclamationCircleOutlined, LoadingOutlined, PlusOutlined, ShoppingCartOutlined } from "@ant-design/icons";
import { AuthService } from "../../services/AuthService";
import moment from "moment";
import StoreContext from "../../context/storeContext";
import LayoutContext from "../../context/layoutContext";
import { UserContext } from "../../context/userContext";
import { getItemCartQuantity, getTotalStock, isInCart } from "../../helpers";
import ButtonGroup from "antd/es/button/button-group";
import { DeleteOutlined } from "@ant-design/icons";
// import { addToCart } from "../../helpers";
const { Text, Title } = Typography;

const IS_MANAGER = true;



const RenderActions = () => {

    const confirm: PopconfirmProps['onConfirm'] = (e) => {
        console.log(e);
        message.success('Click on Yes');
    };

    return (
        <div>
            <Button danger>Delete</Button>
        </div>
    )
}


const Articles = () => {

    const navigate = useNavigate();
    const [messageApi, contextHolder] = message.useMessage();
    const { user } = useContext(UserContext);

    const { cart, addToCart, emptyCart, updateCartQuantity } = useContext(StoreContext);

    const [loading, setLoading] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [dataSource, setDataSource] = useState([]);
    const [filteredData, setFilteredData] = useState(dataSource);

    const [cartLoading, setCartLoading] = useState({})

    const [columns, setColumns] = useState([

        {
            title: 'Shifra e Prodhuesit',
            dataIndex: 'barcode',
            key: 'barcode',
        },
        {
            title: 'Numri i Katalogut',
            dataIndex: 'productNo',
            key: 'productNo',
        },
        {
            title: 'Përshkrimi',
            dataIndex: 'description',
            key: 'description',
        },
        // {
        //     title: 'PERSHKRIM',
        //     dataIndex: 'description',
        //     key: 'description',
        //     width: "30%"
        // },
        {
            title: 'Brendi',
            dataIndex: 'brandName',
            key: 'brandName',
        },
        {
            title: 'Çmimi',
            dataIndex: 'pr',
            key: 'pr',
        },
        
       

        ...((user?.details?.roleName === 'Admin' || user?.details?.roleName === 'Manager' || user?.details?.roleName === 'User') ? [{
            title: 'Çmimi Intern',
            dataIndex: 'internalPrice',
            key: 'internalPrice',
        },{
            title: 'Stoku',
            dataIndex: 'availability',
            key: 'availability',
        }] : []),
        {
            title: 'Delete',
            dataIndex: 'deleteButton',
            key: 'deleteButton',
        },
        // {
        //     title: 'Shto',
        //     key: 'action',
        //     render: (_, record) => {
        //         const addedToCart = isInCart(cart, record);

        //         return (
        //             <>

        //                 {/* <ButtonGroup>
        //                     <InputNumber size="small" min={1} max={getTotalStock(record)} onChange={(val) => updateItemQuantity(record, val)} value={Number()} className="quantity-input" />
        //                     <Button size="small" onClick={() => alert(record)} icon={<PlusOutlined />} />
        //                 </ButtonGroup> */}
        //                 <Button disabled={getTotalStock(record) < 1} type={"primary"} style={{ backgroundColor: getTotalStock(record) == 0 ? "red" : getTotalStock(record) <= 5 ? "orange" : "#41B3A2" }} size="small" icon={<ShoppingCartOutlined />} onClick={() => handleAddToCart(record)} />

        //             </>
        //         );
        //     }
        // },
        {
            title: 'Shto',
            dataIndex: 'cart',
            key: 'cart',
        },

        

    ])




    const handleAddToCart = async (record) => {

        console.log("RECORD", record)

        addToCart(record, 1);

        messageApi.open({
            type: 'success',
            content: 'Produkti u shtua ne shporte',
        });
        // addToCart(record);
        // return;

        // getProducts();

        // setCartLoading(prev => ({ ...prev, [record.productId]: true }));
        // await test(record);
        // setCartLoading(prev => ({ ...prev, [record.productId]: false }));

    }

    const getProducts = async (discounted = false) => {
        setLoading(true);


        let res = discounted ? await AuthService.getDiscountedProducts({}) : await AuthService.getProducts({});
        console.log("get products", res);
        if (res) {
            let updated = res.map(el => {
                let updatedEl = { ...el };

                // Check for storeStocks and create availability badges
                if (el.storeStocks) {
                    const availability = Object.keys(el?.storeStocks ?? {}).map(store => (
                        // <Badge key={store} count={el.storeStocks[store]} color="green" title={store} />
                        <Tag icon={<CheckCircleOutlined />} color={el?.storeStocks[store] == 0 ? "red" : el?.storeStocks[store] <= 5 ? "orange" : "green"}>{store} {user?.details?.roleName === 'User' ? "" : el?.storeStocks[store]}</Tag>
                    ));
                    updatedEl.availability = availability;
                }

                const priceContent = el.discountedPrice < el.price && el.discountedPrice > 0
                    ? (
                        // <Tooltip title={`Cmimi me shumice eshte ${el?.discountedPrice}€`} color={"geekblue"} key={"color"}>
                            <div>
                               
                                    {user?.details?.roleName !== "User" ? (
                                     <p><span style={{ textDecoration: "line-through", fontSize: '0.85rem' }}>{el.price}€</span><br />{el.discountedPrice}€</p>

                                    ): <p><span style={{ fontSize: '0.85rem' }}>{el.discountedPrice}€</span></p> }
                            </div>
                        // </Tooltip>
                    )
                    : (
                        <div>
                            <p>{el.price}€</p>
                        </div>
                    );


                updatedEl.supplyDate = moment(updatedEl.supplyDate).format("MM.DD.YY");
                updatedEl.pr = priceContent;
                updatedEl.internalPrice = el.internalPrice ? `${el.internalPrice}€` : ""

                //Cart button
                const cartRender = <AddToCartItem product={el} onAdd={addToCart} />
                updatedEl.cart = cartRender;
                updatedEl.deleteButton =  <Button type="primary" size="small" danger onClick={()=>deleteProduct(el?.productId)}><DeleteOutlined /></Button>

                return updatedEl;
            });
            console.log("updated", updated)
            setDataSource(updated);
            setFilteredData(updated)

        }
        setLoading(false);
    };

    const deleteProduct = async(productId) => {
        if(!productId) return;
        let res = await AuthService.deleteProduct(productId);
        console.log("res", res);
        getProducts();
    }

    const handleSearch = (e) => {
        const value = e.target.value;
        setSearchText(value);
        const filtered = dataSource.filter((item) =>
            Object.keys(item).some((key) =>
                item[key]?.toString()?.toLowerCase()?.includes(value.toLowerCase())
            )
        );
        setFilteredData(filtered);
    };

    const handleRowClick = (record) => {
        // let obj = record.id;
        console.log("record", record);
        const { pr, availability, cart, ...productWithoutPr } = record;

        console.log(productWithoutPr);

        navigate("/article", { state: { product: productWithoutPr } });
        // navigate("/orders/view", { state: { order: record } });
    }

    useEffect(() => {
        getProducts();
    }, [])

    return (

        <>
            <div className="container">
                {contextHolder}


                <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap">
                    <Title level={4} style={{ fontWeight: '400', fontFamily: 'Source Sans 3' }}>Produktet</Title>


                </div>
                <div className="d-flex justify-content-between align-items-cente flex-wrap">
                    <Segmented<string>

                        options={['Të gjitha', 'Në zbritje',]}
                        onChange={(value) => {
                            console.log(value); // string
                            getProducts(value == "Në zbritje" ? true : false);
                        }}
                    />
                    <div className="d-flex justify-content-end w-100 flex-wrap" style={{ marginLeft: 10 }}>
                        <Input
                            placeholder="Filtro produktet..."
                            value={searchText}
                            onChange={handleSearch}
                            style={{ maxWidth: 450, width: "450px", marginRight: 20, padding: 10 }}
                        />

                        {(user?.details?.roleName == "Admin" || user?.details?.roleName == "Manager") && (
                            <Link to="/articles/new">
                                <Button type="primary" icon={<PlusOutlined />}>Shto një të ri</Button>
                            </Link>
                        )}
                    </div>
                </div>
                <div style={{ overflowX: "auto" }}>
                    <Spin spinning={loading} tip="Duke procesuar te dhenat..."><Table dataSource={filteredData} size="small" pagination={{ pageSize: 50 }} columns={columns} rowKey={"productId"} style={{ width: "100%", marginTop: 20 }} onRow={(record) => ({
                        onDoubleClick: () => {
                            // handleRowClick(record);
                        },
                    })} /></Spin>

                </div>

            </div>


        </>
    )
}

export default Articles;


const AddToCartItem = ({ product, onAdd }) => {
    const [quantity, setQuantity] = useState(1);

    return (
        <ButtonGroup>
            <InputNumber disabled={getTotalStock(product) < 1} size="small" min={1} max={getTotalStock(product)} onChange={(val) => setQuantity(val)} value={quantity} className="quantity-input" style={{ color: "black" }} />

            <Button disabled={getTotalStock(product) < 1} type={"primary"} style={{ backgroundColor: getTotalStock(product) == 0 ? "red" : getTotalStock(product) <= 5 ? "orange" : "#41B3A2" }} size="small" icon={<ShoppingCartOutlined />} onClick={() => { 
                console.log({ product, quantity }); 
                    if(getTotalStock(product) < 1){
                        alert("Ska stok")
                    }
                    else{
                        onAdd(product, quantity == 0 ? 1 : quantity) 
                    }
                
                }} />

        </ButtonGroup>
    )
}